import { render, staticRenderFns } from "./DocIcon.vue?vue&type=template&id=2cb9a60b&"
import script from "./DocIcon.vue?vue&type=script&lang=js&"
export * from "./DocIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports